import { CODEBTOR_SET_DATA, CODEBTOR_TRIGGER_SET_DATA } from '../actions';

const INIT_STATE = {
    id: null,
    id_codeudor: null,
    numero_identificacion: null,
    triggerSubmit: { id: '', name: '' },
};

const codebtorReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CODEBTOR_SET_DATA:
            return Object.assign({}, state, action.payload);
        case CODEBTOR_TRIGGER_SET_DATA:
            return Object.assign({}, state, {
                triggerSubmit: action.payload,
            });
        default:
            return { ...state };
    }
};

export default codebtorReducer;
